import { useTranslation } from 'react-i18next'
import { HiArrowDownTray, HiChevronRight, HiDocumentText } from 'react-icons/hi2'

interface DescargaModalProps {
  productoNombre: string | null
  descargando: boolean
  onDescargar: () => void
  onClose: () => void
}

export function DescargaModal({ productoNombre, descargando, onDescargar, onClose }: DescargaModalProps) {
  const { t } = useTranslation('simulador')

  return (
    <div
      className="fixed inset-0 z-[9998] flex items-center justify-center p-6"
      role="dialog"
      aria-modal="true"
      aria-labelledby="descarga-modal-title"
    >
      <div
        className="absolute inset-0 bg-black/35"
        onClick={descargando ? undefined : onClose}
      />
      <div className="relative z-[1] flex w-[min(100%,28rem)] flex-col items-center gap-2 rounded-sm bg-white px-7 pt-8 pb-6 text-center shadow-[0_1.5rem_3rem_rgba(13,26,48,0.18)]">

        <div className="mb-1 flex h-13 w-13 items-center justify-center rounded-pill border-[1.5px] border-border-soft bg-surface-accent-soft text-brand-primary">
          <HiArrowDownTray size={26} />
        </div>

        <h2
          id="descarga-modal-title"
          className="m-0 text-[1.125rem] font-bold text-text-primary"
        >
          {t('descargaTitle')}
        </h2>
        <p className="m-0 text-[0.875rem] leading-normal text-text-muted">
          {t('descargaSubtitle')}
        </p>

        <div className="mt-3 mb-2 h-px w-full bg-border-soft" />

        <div className="mb-1 flex w-full flex-col gap-1 text-left">
          <span className="text-[0.75rem] font-semibold tracking-[0.06em] text-text-muted uppercase">
            {t('descargaDocLabel')}
          </span>
          <span className="text-[1rem] font-semibold text-text-primary">
            {productoNombre
              ? t(`productoNombres.${productoNombre}`, { defaultValue: productoNombre })
              : productoNombre}
          </span>
        </div>

        <button
          type="button"
          className="flex w-full cursor-pointer items-center gap-3.5 rounded-md border border-border-soft bg-white px-4 py-3.5 text-left [transition:background-color_150ms_ease,border-color_150ms_ease] enabled:hover:border-brand-primary enabled:hover:bg-surface-accent-soft disabled:cursor-not-allowed disabled:opacity-60"
          onClick={onDescargar}
          disabled={descargando}
        >
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-sm bg-[#fde8e8] text-[#c0392b]">
            <HiDocumentText size={22} />
          </div>
          <div className="flex flex-1 flex-col gap-0.5">
            <span className="text-[0.9375rem] font-semibold text-text-primary">
              {descargando ? t('downloading') : t('descargaPdfTitle')}
            </span>
            <span className="text-[0.8125rem] leading-[1.4] text-text-muted">
              {t('descargaPdfDesc')}
            </span>
          </div>
          <HiChevronRight className="shrink-0 text-text-muted" size={20} />
        </button>

        <button
          type="button"
          className="mt-2 cursor-pointer border-none bg-transparent px-2 py-1 text-[0.9375rem] font-medium text-brand-primary [transition:opacity_150ms_ease] hover:opacity-75 disabled:cursor-not-allowed disabled:text-text-muted disabled:opacity-45"
          onClick={onClose}
          disabled={descargando}
        >
          {t('descargaCancelar')}
        </button>

      </div>
    </div>
  )
}
